import React from "react";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import "../styles/disbilityDashboardStyle.css";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
export const DisablilityListingCard = ({
  dataList,
  moduleData,
  step,
  loading,
}) => {
  const allowedKeys = [
    "Attorney",
    "Financial Advisor",
    "Insurance Agent",
    "Accountant/CPA",
    "Care Manager",
    "Social Worker",
  ];
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <div className="DisabilityCardMain" style={{ position: "relative" }}>
      <div className="cardHeadingDisability">
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
         {moduleData.Icon && <img
            width={66}
            height={56}
            src={moduleData.Icon}
            alt={moduleData.name}
          ></img>}

          {/* {moduleData.name} */}
          <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
            {moduleData.name}
            {moduleData &&
              moduleData.tooltip &&
              ["Primary Caregivers", "Professional Contacts"].includes(moduleData.name) && (
                <ToolTipCreator name={moduleData.tooltip} />
            )}
          </div>           
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/disability");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div className="disabilityDashboardListing">
        {moduleData.name === "Primary Caregivers" ? (
          <React.Fragment>
            {dataList && dataList.length > 0 ? (
              dataList.map((item, index) => (
                <div key={index} className="disabilityDashboardListingRow">
                  <div className="checkListName">
                    {item.Name ? item.Name : "N/A"}
                  </div>
                  <div className="emailStatus">
                    {item.Relationship ? item.Relationship : "N/A"}
                  </div>
                </div>
              ))
            ) : (
              <div className="disabilityDashboardListingNoData">
                No data to show
              </div>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {dataList && dataList.length > 0 ? (
              Object.entries(dataList[0])
                .filter(([key, value]) => allowedKeys.includes(key) && value) // Only include specified keys with values
                .map(([key, value], index) => (
                  <div key={index} className="disabilityDashboardListingRow">
                    <div className="checkListName">{key}</div>
                    <div className="emailStatus">{value || ""}</div>
                  </div>
                ))
            ) : (
              <div className="disabilityDashboardListingNoData">
                No data to show
              </div>
            )}
          </React.Fragment>
        )}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
